<template>
  <div class="my-payment-container">
    <!-- 页头 -->
    <div class="gradient-header">
      <div class="checkerboard-overlay"></div>
      <div class="header-content">
        <div class="header-icon">
          <i class="el-icon-money"></i>
        </div>
        <span>我的付款申请</span>
      </div>
    </div>

    <!-- 搜索栏 -->
    <el-card class="search-card">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="关键字">
          <el-input v-model="searchForm.keyword" placeholder="请输入关键字" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
            <el-option label="全部" value="-1"></el-option>
            <el-option label="待审核" value="2"></el-option>
            <el-option label="审核中" value="3"></el-option>
            <el-option label="已通过" value="4"></el-option>
            <el-option label="已拒绝" value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 表格 -->
    <el-card class="table-card" v-loading="loading">
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column prop="order_name" label="订单名称" min-width="180"></el-table-column>
        <el-table-column prop="now_approver" label="当前审批人" min-width="120"></el-table-column>
        <el-table-column prop="money" label="申请金额" width="120" align="right">
          <template slot-scope="{row}">
            <span style="color: #f56c6c;">¥{{ row.money }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="{row}">
            <el-tag :type="getStatusType(row.status)">
              {{ getStatusText(row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="申请时间" min-width="160">
          <template slot-scope="{row}">
            {{ formatDateTime(row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="approve_time" label="审核时间" min-width="160">
          <template slot-scope="{row}">
            {{ row.approve_time ? formatDateTime(row.approve_time) : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleDetail(row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchForm.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="searchForm.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'MyPayment',
  data() {
    return {
      loading: false,
      searchForm: {
        keyword: '',
        status: '-1',
        page: 1,
        pageSize: 10
      },
      tableData: [],
      total: 0
    }
  },
  mounted() {
    console.log('MyPayment component mounted')
    this.fetchData()
  },
  methods: {
    // 获取列表数据
    async fetchData() {
      try {
        this.loading = true
        console.log('Fetching payment data...')
        const res = await request({
          url: '/api/v1/purchasing-order/payment/list',
          method: 'post',
          data: {
            keyword: this.searchForm.keyword,
            status: this.searchForm.status,
            page: this.searchForm.page,
            pageSize: this.searchForm.pageSize
          }
        })

        console.log('Payment data response:', res)

        if (res.status === 1) {
          this.tableData = res.data.list
          this.total = res.data.total
        }
      } catch (error) {
        console.error('获取付款申请列表失败:', error)
        this.$message.error('获取列表失败')
      } finally {
        this.loading = false
      }
    },

    // 处理搜索
    handleSearch() {
      this.searchForm.page = 1
      this.fetchData()
    },

    // 重置表单
    resetForm() {
      this.searchForm = {
        keyword: '',
        status: '-1',
        page: 1,
        pageSize: 10
      }
      this.fetchData()
    },

    // 处理查看详情
    handleDetail(row) {
      this.$router.push({
        path: '/finance/mypayment/detail',
        query: { id: row.id }
      })
    },

    // 处理分页大小改变
    handleSizeChange(val) {
      this.searchForm.pageSize = val
      this.fetchData()
    },

    // 处理页码改变
    handleCurrentChange(val) {
      this.searchForm.page = val
      this.fetchData()
    },

    // 获取状态类型
    getStatusType(status) {
      const typeMap = {
        2: 'warning',  // 待审核
        3: 'primary',  // 审核中
        4: 'success',  // 已通过
        5: 'danger'    // 已拒绝
      }
      return typeMap[status] || 'info'
    },

    // 获取状态文本
    getStatusText(status) {
      const textMap = {
        2: '待审核',
        3: '审核中',
        4: '已通过',
        5: '已拒绝'
      }
      return textMap[status] || '未知'
    },

    // 格式化时间
    formatDateTime(date) {
      if (!date) return '-'
      const d = new Date(date)
      if (isNaN(d.getTime())) return '-'
      
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hour = String(d.getHours()).padStart(2, '0')
      const minute = String(d.getMinutes()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hour}:${minute}`
    }
  }
}
</script>

<style lang="scss" scoped>
.my-payment-container {
  padding: 20px;
}

.gradient-header {
  height: 80px;
  background: linear-gradient(90deg, #409EFF 0%, #40E0D0 100%);
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 24px;
  color: white;
  font-size: 18px;
  border-radius: 4px;
  margin-bottom: 20px;
  
}

.checkerboard-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: linear-gradient(45deg, rgba(255,255,255,0.1) 25%, transparent 25%), linear-gradient(-45deg, rgba(255,255,255,0.1) 25%, transparent 25%), linear-gradient(45deg, transparent 75%, rgba(255,255,255,0.1) 75%), linear-gradient(-45deg, transparent 75%, rgba(255,255,255,0.1) 75%);
  background-size: 20px 20px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
}

.header-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
}

.header-icon {
  margin-right: 12px;
}

.header-icon i {
  font-size: 24px;
}

.search-card {
  margin-bottom: 20px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style> 